import { createEnduroProgram } from "./enduroPrograms";
export const PROGRAM_ENDURO_45 = createEnduroProgram(4);
